/** @module FilterDefinition */
import labelFromJsonPointer from '@/components/query/helpers/label-from-json-pointer';

/**
 * Structure used to control the properties within filter definitions.
 */
export default class FilterDefinition {
    static types = {
        default: 'default',
        customField: 'customField',
    };

    type = FilterDefinition.types.default;

    path = null;

    options = null;

    format = null;

    customFieldFormat = null;

    additionalSchema = null;

    label = null;

    /**
     * Set the filter schema.
     * @param path
     * @param format
     * @param type
     * @param options
     * @param customFieldFormat
     * @param additionalSchema
     * @param label
     */
    constructor({
        path,
        format,
        type = FilterDefinition.types.default,
        options = null,
        customFieldFormat = null,
        additionalSchema = null,
        label = null,
    }) {
        if (path === null) {
            throw new Error('Undefined filter path.');
        }
        if (type === null) {
            throw new Error('Undefined filter type.');
        }

        this.path = path;
        this.format = format;
        this.type = type;
        this.options = options;
        this.customFieldFormat = customFieldFormat;
        this.additionalSchema = additionalSchema;
        this.label = label || labelFromJsonPointer(path);
    }
}
